import { render, staticRenderFns } from "./Myevaluation.vue?vue&type=template&id=2e74008b&scoped=true&"
import script from "./Myevaluation.vue?vue&type=script&lang=js&"
export * from "./Myevaluation.vue?vue&type=script&lang=js&"
import style0 from "./Myevaluation.vue?vue&type=style&index=0&id=2e74008b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e74008b",
  null
  
)

export default component.exports